'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _style = require('./style');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Block(props) {
  var _props$nameWidth = props.nameWidth,
      nameWidth = _props$nameWidth === undefined ? 100 : _props$nameWidth,
      _props$inputWidth = props.inputWidth,
      inputWidth = _props$inputWidth === undefined ? 200 : _props$inputWidth,
      name = props.name,
      required = props.required,
      children = props.children;


  return _react2.default.createElement(
    'div',
    { className: _style2.default['col-container'] },
    _react2.default.createElement(
      'div',
      { className: _style2.default['col-title'], style: { width: nameWidth } },
      name || '',
      required && _react2.default.createElement(
        'span',
        { className: _style2.default['require-tag'] },
        ' (\u5FC5\u586B)'
      )
    ),
    _react2.default.createElement(
      'div',
      { className: _style2.default['col-input'], style: { minWidth: inputWidth } },
      children
    )
  );
}
var bool = _propTypes2.default.bool,
    number = _propTypes2.default.number,
    string = _propTypes2.default.string,
    element = _propTypes2.default.element;

Block.propTypes = {
  required: bool,
  name: string,
  nameWidth: number,
  inputWidth: number,
  children: element
};

exports.default = Block;


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/DocEditor/Block/Block.js
// module id = 1770
// module chunks = 0